import PropTypes from "prop-types"

export const MetricTypeOptionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  unit: PropTypes.string,
  selected: PropTypes.bool,
})

export const MetricItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  metricTypeOptions: PropTypes.arrayOf(MetricTypeOptionShape),
})

export const ColumnShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  contentSetId: PropTypes.string,
  proprietary: PropTypes.bool,
  items: PropTypes.arrayOf(MetricItemShape),
})

export const AvailableColumnShape = PropTypes.shape({
  item: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(ColumnShape).isRequired,
})

export const SubcategoryShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  selectedItemsCount: PropTypes.number,
  itemsCount: PropTypes.number,
  items: PropTypes.arrayOf(MetricItemShape),
})

export const CategoryShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  shouldShowItem: PropTypes.bool.isRequired,
  itemsFound: PropTypes.number.isRequired,
  itemsSelected: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(SubcategoryShape),
})

export const AvailableMetricsShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  items: PropTypes.arrayOf(CategoryShape).isRequired,
})

export const MetricsTemplateConfigShape = PropTypes.shape({
  metrics: PropTypes.arrayOf(PropTypes.string).isRequired,
})

export const MetricsTemplateShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  config: MetricsTemplateConfigShape.isRequired,
})
